import { Component, Input } from '@angular/core';
import { NavigationItem } from 'app/core/navigation/navigation.types';

@Component({
    selector: 'app-horizontal-nav-spacer-item',
    template: '',
    styles: [':host { margin: 12px 0; display: block; }'],
    standalone: false
})
export class HorizontalNavSpacerItemComponent {
    @Input() item!: NavigationItem;
}
